export const formatAuctionId = vehicle =>
  vehicle.auctionSlug ? `${vehicle.auctionSlug}/${vehicle.orderIndex || '-'}` : 'N/A';
